module.exports = __webpack_public_path__ + "img/29.ddac19ae.png";